import React from 'react';
import { Heading } from '@printdeal/ui-library';
import { FormattedMessage, useIntl } from 'react-intl';
import { StoreToggle, FeatureToggle } from '@printdeal/feature-management/react';

import { messages } from '../../translations/general';

import Breadcrumb from '../../../Breadcrumb';
import Head from '../../../PrivateHead';
import CustomerProgramWidget from '../../../customer-programs/CustomerProgramWidget';
import AccountLinks from './AccountLinks';
import ProductsForAudiences from './ProductsForAudiences';

const AccountDashboardPage = () => {
  const intl = useIntl();

  return (
    <>
      <Head title={intl.formatMessage(messages.indexTitle)} />

      <Breadcrumb className="pd-mb-6">
        <Breadcrumb.Item isCurrentPage>
          <FormattedMessage id="account.index.title" defaultMessage="My Account" />
        </Breadcrumb.Item>
      </Breadcrumb>

      <Heading size="2">
        <FormattedMessage id="account.index.title" defaultMessage="My account" />
      </Heading>

      <StoreToggle id="drukwerkdeal-nl_printdeal-be">
        <StoreToggle.Enabled>
          <CustomerProgramWidget />
        </StoreToggle.Enabled>
      </StoreToggle>

      <AccountLinks />

      <FeatureToggle id="product_list_on_account_dashboard">
        <FeatureToggle.Enabled>
          <ProductsForAudiences />
        </FeatureToggle.Enabled>
      </FeatureToggle>
    </>
  );
};

export default AccountDashboardPage;
